// 媒体处理相关功能
import { atom } from 'jotai';
import { supabase } from '../../../lib/supabase';

/**
 * 上传图片
 */
export const uploadImageAtom = atom(
  null,
  async (_get, _set, file: File) => {
    try {
      const uniqueId = Math.random().toString(36).substring(2, 15);
      const fileExt = file.name.split('.').pop();
      const fileName = `${uniqueId}.${fileExt}`;
      const filePath = `chat-media/${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from('media')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const { data: urlData } = supabase.storage
        .from('media')
        .getPublicUrl(filePath);

      const publicUrl = urlData.publicUrl;

      const { data: mediaData, error: mediaError } = await supabase
        .from('media')
        .insert({
          type: file.type,
          url: publicUrl,
          path: filePath,
          size: file.size
        })
        .select('id')
        .single();

      if (mediaError) throw mediaError;

      return mediaData.id;
    } catch (error) {
      console.error('Failed to upload image:', error);
      throw error;
    }
  }
);
